import axios from 'axios'
import {
  GET_AUDIT_LOGS_REQUEST,
  GET_AUDIT_LOGS_SUCCESS,
  GET_AUDIT_LOGS_FAIL,
  GET_AUDIT_LOG_BY_ID_REQUEST,
  GET_AUDIT_LOG_BY_ID_SUCCESS,
  GET_AUDIT_LOG_BY_ID_FAIL,
  GET_AUDIT_LOG_STATS_REQUEST,
  GET_AUDIT_LOG_STATS_SUCCESS,
  GET_AUDIT_LOG_STATS_FAIL,
  GET_PENDING_REVIEWS_REQUEST,
  GET_PENDING_REVIEWS_SUCCESS,
  GET_PENDING_REVIEWS_FAIL,
  MARK_AS_REVIEWED_REQUEST,
  MARK_AS_REVIEWED_SUCCESS,
  MARK_AS_REVIEWED_FAIL,
  GET_SECURITY_ALERTS_REQUEST,
  GET_SECURITY_ALERTS_SUCCESS,
  GET_SECURITY_ALERTS_FAIL,
  GET_USER_ACTIVITY_REQUEST,
  GET_USER_ACTIVITY_SUCCESS,
  GET_USER_ACTIVITY_FAIL,
  EXPORT_AUDIT_LOGS_REQUEST,
  EXPORT_AUDIT_LOGS_SUCCESS,
  EXPORT_AUDIT_LOGS_FAIL,
  BULK_MARK_REVIEWED_REQUEST,
  BULK_MARK_REVIEWED_SUCCESS,
  BULK_MARK_REVIEWED_FAIL,
} from '../constants/auditTrailConstants'

const baseUrl = process.env.REACT_APP_API_URL

// Get audit logs with filters
export const getAuditLogs = (filters = {}) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_AUDIT_LOGS_REQUEST })

    const {
      adminLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    // Build query string from filters
    const queryParams = new URLSearchParams()
    if (filters.page) queryParams.append('page', filters.page)
    if (filters.limit) queryParams.append('limit', filters.limit)
    if (filters.action) queryParams.append('action', filters.action)
    if (filters.resource) queryParams.append('resource', filters.resource)
    if (filters.severity) queryParams.append('severity', filters.severity)
    if (filters.module) queryParams.append('module', filters.module)
    if (filters.startDate) queryParams.append('startDate', filters.startDate)
    if (filters.endDate) queryParams.append('endDate', filters.endDate)
    if (filters.search) queryParams.append('search', filters.search)

    const queryString = queryParams.toString()
    const url = `${baseUrl}/audit-logs${queryString ? `?${queryString}` : ''}`
    console.log('Fetching audit logs from:', url)

    const { data } = await axios.get(url, config)

    dispatch({
      type: GET_AUDIT_LOGS_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: GET_AUDIT_LOGS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

// Get single audit log by ID
export const getAuditLogById = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_AUDIT_LOG_BY_ID_REQUEST })

    const {
      adminLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    console.log('Fetching audit log by ID:', id)
    const { data } = await axios.get(`${baseUrl}/audit-logs/${id}`, config)

    dispatch({
      type: GET_AUDIT_LOG_BY_ID_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: GET_AUDIT_LOG_BY_ID_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

// Get audit log statistics
export const getAuditLogStats = (filters = {}) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_AUDIT_LOG_STATS_REQUEST })

    const {
      adminLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const queryParams = new URLSearchParams()
    if (filters.startDate) queryParams.append('startDate', filters.startDate)
    if (filters.endDate) queryParams.append('endDate', filters.endDate)

    const queryString = queryParams.toString()
    const url = `${baseUrl}/audit-logs/stats${queryString ? `?${queryString}` : ''}`
    console.log('Fetching audit log stats from:', url)

    const { data } = await axios.get(url, config)

    dispatch({
      type: GET_AUDIT_LOG_STATS_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: GET_AUDIT_LOG_STATS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

// Get pending review audit logs
export const getPendingReviews = (filters = {}) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_PENDING_REVIEWS_REQUEST })

    const {
      adminLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const queryParams = new URLSearchParams()
    if (filters.page) queryParams.append('page', filters.page)
    if (filters.limit) queryParams.append('limit', filters.limit)

    const queryString = queryParams.toString()
    const url = `${baseUrl}/audit-logs/pending-reviews${queryString ? `?${queryString}` : ''}`

    const { data } = await axios.get(url, config)

    dispatch({
      type: GET_PENDING_REVIEWS_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: GET_PENDING_REVIEWS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

// Mark audit log as reviewed
export const markAsReviewed = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: MARK_AS_REVIEWED_REQUEST })

    const {
      adminLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.put(`${baseUrl}/audit-logs/${id}/review`, {}, config)

    dispatch({
      type: MARK_AS_REVIEWED_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: MARK_AS_REVIEWED_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

// Get security alerts (HIGH/CRITICAL severity)
export const getSecurityAlerts = (filters = {}) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_SECURITY_ALERTS_REQUEST })

    const {
      adminLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const queryParams = new URLSearchParams()
    if (filters.page) queryParams.append('page', filters.page)
    if (filters.limit) queryParams.append('limit', filters.limit)
    if (filters.startDate) queryParams.append('startDate', filters.startDate)
    if (filters.endDate) queryParams.append('endDate', filters.endDate)

    const queryString = queryParams.toString()
    const url = `${baseUrl}/audit-logs/security-alerts${queryString ? `?${queryString}` : ''}`

    const { data } = await axios.get(url, config)

    dispatch({
      type: GET_SECURITY_ALERTS_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: GET_SECURITY_ALERTS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

// Get user activity history
export const getUserActivity = (userId, filters = {}) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_USER_ACTIVITY_REQUEST })

    const {
      adminLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const queryParams = new URLSearchParams()
    if (filters.page) queryParams.append('page', filters.page)
    if (filters.limit) queryParams.append('limit', filters.limit)
    if (filters.startDate) queryParams.append('startDate', filters.startDate)
    if (filters.endDate) queryParams.append('endDate', filters.endDate)

    const queryString = queryParams.toString()
    const url = `${baseUrl}/audit-logs/user/${userId}/activity${queryString ? `?${queryString}` : ''}`

    const { data } = await axios.get(url, config)

    dispatch({
      type: GET_USER_ACTIVITY_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: GET_USER_ACTIVITY_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

// Export audit logs as CSV
export const exportAuditLogs = (filters = {}) => async (dispatch, getState) => {
  try {
    dispatch({ type: EXPORT_AUDIT_LOGS_REQUEST })

    const {
      adminLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
      responseType: 'blob',
    }

    const queryParams = new URLSearchParams()
    if (filters.action) queryParams.append('action', filters.action)
    if (filters.resource) queryParams.append('resource', filters.resource)
    if (filters.severity) queryParams.append('severity', filters.severity)
    if (filters.startDate) queryParams.append('startDate', filters.startDate)
    if (filters.endDate) queryParams.append('endDate', filters.endDate)
    if (filters.limit) queryParams.append('limit', filters.limit)

    const queryString = queryParams.toString()
    const url = `${baseUrl}/audit-logs/export${queryString ? `?${queryString}` : ''}`

    const response = await axios.get(url, config)

    // Create download link
    const blob = new Blob([response.data], { type: 'text/csv' })
    const downloadUrl = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = downloadUrl
    link.setAttribute('download', `audit_logs_${new Date().toISOString().split('T')[0]}.csv`)
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(downloadUrl)

    dispatch({
      type: EXPORT_AUDIT_LOGS_SUCCESS,
    })
  } catch (error) {
    dispatch({
      type: EXPORT_AUDIT_LOGS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

// Bulk mark audit logs as reviewed
export const bulkMarkAsReviewed = (ids) => async (dispatch, getState) => {
  try {
    dispatch({ type: BULK_MARK_REVIEWED_REQUEST })

    const {
      adminLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.put(`${baseUrl}/audit-logs/bulk-review`, { ids }, config)

    dispatch({
      type: BULK_MARK_REVIEWED_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: BULK_MARK_REVIEWED_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}
